import { useCurrentUserProfile } from "@/hooks/current-user-profile.hook";
import { Navigate } from "react-router-dom";

const WelcomePage = () => {
  const { data: userProfile } = useCurrentUserProfile();

  if (userProfile?.role.startsWith("ORG_")) {
    return <Navigate to="/" replace />;
  } else {
    window.location.href = import.meta.env.VITE_BACKOFFICE_APP_URL;
    return null;
  }
};

export default WelcomePage;
